module.exports = "//cdn.livechat-static.com/webapp/img/insights.png?394167c1f2163091d3744b638840edfd";